import React, { useEffect } from 'react';
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  Label,
  CustomInput,
  FormGroup,
  Button,
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import toastr from 'toastr';
import usePost from '../../helpers/hooks/usePost';
import { useHistory } from 'react-router-dom';
const CcrNew = (props) => {
  const history = useHistory();
  const [postCcr, postedData, postingError, dataPosting] = usePost(
    '/ccrs'
  );
  const handleFormSubmit = (event, errors, values) => {
    if (dataPosting) {
      return;
    }
      const obj = {
        ...values,
      };
      postCcr(obj);
    
  };
  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Ccr has been created successfully');
      history.push('/users/ccr');
    }
  }, [history, postedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleFormSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Add New Ccr</h4>
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label htmlFor='name'>First Name</Label>
                      <AvField
                        name='firstName'
                        placeholder='First Name'
                        type='text'
                        errorMessage='Enter First Name'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='firstName'
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label htmlFor='name'>Last Name</Label>
                      <AvField
                        name='lastName'
                        placeholder='Last Name'
                        type='text'
                        errorMessage='Enter Last Name'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='lastName'
                      />
                      </FormGroup>
                    <FormGroup>
                      <Label htmlFor='name'>Email</Label>
                      <AvField
                        name='email'
                        placeholder='Email'
                        type='email'
                        errorMessage='Enter Email'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='email'
                      />

                    </FormGroup>
                    <div className='border mb-3 mt-2'></div>
                    <FormGroup>
                      <Label htmlFor='password'>Set Password</Label>
                      <AvField
                        name='password'
                        placeholder='Password'
                        type='text'
                        errorMessage='Minimun length required is 5'
                        className='form-control'
                        validate={{
                          required: { value: true },
                          minLength: { value: 5 },
                        }}
                        id='password'
                      />
                    </FormGroup>
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting }
                    >
                    {dataPosting
                      ? 'Saving...'
                      : 'Save Ccr'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};

export default CcrNew;
